import { CountryCode as LibphonenumberCountryCode } from "libphonenumber-js"

type MobileCallingCodeData = {
  country: string
  mask: string
  flag: string
  countryCode: LibphonenumberCountryCode
  callingCode: string
}
export const MOBILE_CALLING_CODES = {
  US: {
    country: "United States",
    mask: "000-000-0000",
    flag: "US",
    countryCode: "US",
    callingCode: "1",
  },
  CA: {
    country: "Canada",
    mask: "000-000-0000",
    flag: "CA",
    countryCode: "CA",
    callingCode: "1",
  },
  GB: {
    country: "United Kingdom",
    mask: "07 0000 00000",
    flag: "GB",
    countryCode: "GB",
    callingCode: "44",
  },
  DE: {
    country: "Germany",
    mask: "0 15 0000 0000",
    flag: "DE",
    countryCode: "DE",
    callingCode: "49",
  },
  ES: {
    country: "Spain",
    mask: "6 000 000 000",
    flag: "ES",
    countryCode: "ES",
    callingCode: "34",
  },
  FR: {
    country: "France",
    mask: "0 6 00 00 00 00",
    flag: "FR",
    countryCode: "FR",
    callingCode: "33",
  },
  IT: {
    country: "Italy",
    mask: "3 00 000 0000",
    flag: "IT",
    countryCode: "IT",
    callingCode: "39",
  },
  MX: {
    country: "Mexico",
    mask: "000 000 0000",
    flag: "MX",
    countryCode: "MX",
    callingCode: "52",
  },
  NL: {
    country: "Netherlands",
    mask: "06 00000000",
    flag: "NL",
    countryCode: "NL",
    callingCode: "31",
  },
  GR: {
    country: "Greece",
    mask: "69 0000 0000",
    flag: "GR",
    countryCode: "GR",
    callingCode: "30",
  },
  AU: {
    country: "Australia",
    mask: "04 0000 0000",
    flag: "AU",
    countryCode: "AU",
    callingCode: "61",
  },
  JP: {
    country: "Japan",
    mask: "0 90 0000 0000",
    flag: "JP",
    countryCode: "JP",
    callingCode: "81",
  },
  BR: {
    country: "Brazil",
    mask: "00 9 0000 0000",
    flag: "BR",
    countryCode: "BR",
    callingCode: "55",
  },
  CR: {
    country: "Costa Rica",
    mask: "0000 0000",
    flag: "CR",
    countryCode: "CR",
    callingCode: "506",
  },
  GL: {
    country: "Greenland",
    mask: "00 00 00",
    flag: "GL",
    countryCode: "GL",
    callingCode: "299",
  },
  GT: {
    country: "Guatemala",
    mask: "0000 0000",
    flag: "GT",
    countryCode: "GT",
    callingCode: "502",
  },
  DO: {
    country: "Dominican Republic",
    mask: "000-000-0000",
    flag: "DO",
    countryCode: "DO",
    callingCode: "1",
  },
  PR: {
    country: "Puerto Rico",
    mask: "000-000-0000",
    flag: "PR",
    countryCode: "PR",
    callingCode: "1",
  },
  TC: {
    country: "Turks and Caicos",
    mask: "000-000-0000",
    flag: "TC",
    countryCode: "TC",
    callingCode: "1",
  },
  VG: {
    country: "British Virgin Islands",
    mask: "000-000-0000",
    flag: "VG",
    countryCode: "VG",
    callingCode: "1",
  },
  CN: {
    country: "China",
    mask: "000 0000 0000",
    flag: "CN",
    countryCode: "CN",
    callingCode: "86",
  },
  HK: {
    country: "Hong Kong",
    mask: "0000 0000",
    flag: "HK",
    countryCode: "HK",
    callingCode: "852",
  },
  IN: {
    country: "India",
    mask: "00000 00000",
    flag: "IN",
    countryCode: "IN",
    callingCode: "91",
  },
  IL: {
    country: "Israel",
    mask: "000-000-0000",
    flag: "IL",
    countryCode: "IL",
    callingCode: "972",
  },
  LB: {
    country: "Lebanon",
    mask: "00 000 000",
    flag: "LB",
    countryCode: "LB",
    callingCode: "961",
  },
  QA: {
    country: "Qatar",
    mask: "0000 0000",
    flag: "QA",
    countryCode: "QA",
    callingCode: "974",
  },
  KR: {
    country: "South Korea",
    mask: "010-0000-0000",
    flag: "KR",
    countryCode: "KR",
    callingCode: "82",
  },
  TW: {
    country: "Taiwan",
    mask: "0900 000 000",
    flag: "TW",
    countryCode: "TW",
    callingCode: "886",
  },
  TH: {
    country: "Thailand",
    mask: "000-000-0000",
    flag: "TH",
    countryCode: "TH",
    callingCode: "66",
  },
  AL: {
    country: "Albania",
    mask: "069 000 0000",
    flag: "AL",
    countryCode: "AL",
    callingCode: "355",
  },
  AT: {
    country: "Austria",
    mask: "0664 000000",
    flag: "AT",
    countryCode: "AT",
    callingCode: "43",
  },
  BY: {
    country: "Belarus",
    mask: "080 000-00-00",
    flag: "BY",
    countryCode: "BY",
    callingCode: "375",
  },
  BE: {
    country: "Belgium",
    mask: "0470 00 00 00",
    flag: "BE",
    countryCode: "BE",
    callingCode: "32",
  },
  BG: {
    country: "Bulgaria",
    mask: "088 000 0000",
    flag: "BG",
    countryCode: "BG",
    callingCode: "359",
  },
  HR: {
    country: "Croatia",
    mask: "091 000 0000",
    flag: "HR",
    countryCode: "HR",
    callingCode: "385",
  },
  DK: {
    country: "Denmark",
    mask: "00 00 00 00",
    flag: "DK",
    countryCode: "DK",
    callingCode: "45",
  },
  FI: {
    country: "Finland",
    mask: "040 0000000",
    flag: "FI",
    countryCode: "FI",
    callingCode: "358",
  },
  HU: {
    country: "Hungary",
    mask: "06 20 000 0000",
    flag: "HU",
    countryCode: "HU",
    callingCode: "36",
  },
  IS: {
    country: "Iceland",
    mask: "000 0000",
    flag: "IS",
    countryCode: "IS",
    callingCode: "354",
  },
  IE: {
    country: "Ireland",
    mask: "08X 000 0000",
    flag: "IE",
    countryCode: "IE",
    callingCode: "353",
  },
  LV: {
    country: "Latvia",
    mask: "2 000 0000",
    flag: "LV",
    countryCode: "LV",
    callingCode: "371",
  },
  LT: {
    country: "Lithuania",
    mask: "6XX XXXXX",
    flag: "LT",
    countryCode: "LT",
    callingCode: "370",
  },
  LU: {
    country: "Luxembourg",
    mask: "621 000 000",
    flag: "LU",
    countryCode: "LU",
    callingCode: "352",
  },
  NO: {
    country: "Norway",
    mask: "000 00 000",
    flag: "NO",
    countryCode: "NO",
    callingCode: "47",
  },
  PL: {
    country: "Poland",
    mask: "600 000 000",
    flag: "PL",
    countryCode: "PL",
    callingCode: "48",
  },
  PT: {
    country: "Portugal",
    mask: "91X XXX XXX",
    flag: "PT",
    countryCode: "PT",
    callingCode: "351",
  },
  RO: {
    country: "Romania",
    mask: "07XX XXX XXX",
    flag: "RO",
    countryCode: "RO",
    callingCode: "40",
  },
  RU: {
    country: "Russian Federation",
    mask: "8 900 000-00-00",
    flag: "RU",
    countryCode: "RU",
    callingCode: "7",
  },
  SK: {
    country: "Slovakia",
    mask: "09XX XXX XXX",
    flag: "SK",
    countryCode: "SK",
    callingCode: "421",
  },
  SI: {
    country: "Slovenia",
    mask: "041 XXX XXX",
    flag: "SI",
    countryCode: "SI",
    callingCode: "386",
  },
  SE: {
    country: "Sweden",
    mask: "07X-XXX XXXX",
    flag: "SE",
    countryCode: "SE",
    callingCode: "46",
  },
  CH: {
    country: "Switzerland",
    mask: "079 000 00 00",
    flag: "CH",
    countryCode: "CH",
    callingCode: "41",
  },
  TR: {
    country: "Turkey",
    mask: "05XX XXX XXXX",
    flag: "TR",
    countryCode: "TR",
    callingCode: "90",
  },
  UA: {
    country: "Ukraine",
    mask: "039 000 0000",
    flag: "UA",
    countryCode: "UA",
    callingCode: "380",
  },
  AR: {
    country: "Argentina",
    mask: "011 15-0000-0000",
    flag: "AR",
    countryCode: "AR",
    callingCode: "54",
  },
  CL: {
    country: "Chile",
    mask: "9 0000 0000",
    flag: "CL",
    countryCode: "CL",
    callingCode: "56",
  },
  CO: {
    country: "Colombia",
    mask: "300 0000000",
    flag: "CO",
    countryCode: "CO",
    callingCode: "57",
  },
  EC: {
    country: "Ecuador",
    mask: "09 000 0000",
    flag: "EC",
    countryCode: "EC",
    callingCode: "593",
  },
  VE: {
    country: "Venezuela",
    mask: "0414 000 0000",
    flag: "VE",
    countryCode: "VE",
    callingCode: "58",
  },
  EG: {
    country: "Egypt",
    mask: "0100 000 0000",
    flag: "EG",
    countryCode: "EG",
    callingCode: "20",
  },
  GH: {
    country: "Ghana",
    mask: "020 000 0000",
    flag: "GH",
    countryCode: "GH",
    callingCode: "233",
  },
  KE: {
    country: "Kenya",
    mask: "0700 000 000",
    flag: "KE",
    countryCode: "KE",
    callingCode: "254",
  },
  ZA: {
    country: "South Africa",
    mask: "060 000 0000",
    flag: "ZA",
    countryCode: "ZA",
    callingCode: "27",
  },
} as const

export type CountryCode = keyof typeof MOBILE_CALLING_CODES
